export const CLASSNAME = 'block-summary';

export const WIDGET_SUMMARY_TYPE = 'summary';
